export const RESEARCH_DESK_NOTE_CATEGORIES = [
  'Summary',
  'Summary fpm',
  'Key Metrics',
  'Balance Sheet',
  'Balance Sheet fpm',
  'Income Statement',
  'Cash Flow',
  'Growth',
  'General Notes',
] as const;

export type ResearchDeskNoteCategory = (typeof RESEARCH_DESK_NOTE_CATEGORIES)[number];
